<script lang="ts" setup>
const { awesome } = useAppConfig()

useHead({
  title: awesome.name,
  // titleTemplate: `%s - ${awesome.name}`,
  titleTemplate: `${awesome.name}`,
})
</script>

<template>
  <Body
    class="antialiased duration-300 transition-colors text-gray-800 bg-white"
  >
    <!-- 暗黑模式已禁用: dark:text-gray-200 dark:bg-gray-950 -->
    <NuxtLayout>
      <NuxtLoadingIndicator />
      <NuxtPage />
    </NuxtLayout>
  </Body>
</template>
